import { ReferralProgramRebuild } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

/**
 * Release switch for the rebuilt referral programme (GOTU-6523 / GOTU-7435).
 *
 * With the flag off the portal has no referral surface at all — the legacy
 * programme was removed outright (GOTU-7165). With it on, v2 links are honoured
 * and signup posts `referredByCode` to referral-service. Every surface reads the
 * flag through this one hook so a session never sees half of the rebuild.
 *
 * `useFeatureFlag` is subscribed, so a mid-session flip moves the surfaces as
 * one. The signup form is the exception: it captures the value once at mount
 * (GOTU-7435) so a flip cannot change the path of a submission in progress.
 *
 * A rollout switch, not an experiment — hence the boolean `useFeatureFlag` and
 * not `useFeatureFlagVariant`.
 */
export const useIsReferralRebuildEnabled = (): boolean => useFeatureFlag(ReferralProgramRebuild);
